import { useEffect, useRef } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useAccountConfig } from '@/hooks/useAccountConfig';
import { doNothing } from '@/utils/doNothing';
import { useMustReadsEnabled } from './useMustReadsEnabled';

// With must-reads on, the API keeps pending ones out of the feed and the unread count: a switch flip changes
// both, so a cached feed must not show a post that "To confirm" shows too.
export const useRefreshFeedOnMustReadsSwitch = (): void => {
  const queryClient = useQueryClient();
  const { isPending } = useAccountConfig();
  const isMustReadsEnabled = useMustReadsEnabled();
  const settledValueRef = useRef<boolean | null>(null);

  useEffect(() => {
    if (isPending) {
      return;
    }
    const previousValue = settledValueRef.current;
    settledValueRef.current = isMustReadsEnabled;
    if (previousValue === null || previousValue === isMustReadsEnabled) {
      return;
    }
    queryClient.invalidateQueries({ queryKey: ['newsfeed'] }).catch(doNothing);
    queryClient.invalidateQueries({ queryKey: ['newsfeed-unread-count'] }).catch(doNothing);
  }, [isPending, isMustReadsEnabled, queryClient]);
};
